import palette from '../palette';
import { colors } from '@material-ui/core';

export default {
  root: {
    backgroundColor: palette.background.color
  }
};
